import { useCallback } from "react";

import { Button, InfoModal, useModal } from "@newsela/angelou";

import CanvasIcon from "./CanvasIcon";
import GoogleClassroomIcon from "./GoogleClassroomIcon";
import {
  canvasIconCss,
  googleIconCss,
  lmsProvidersWrapper,
  modalBodyWrapperCss,
  modalCss,
  modalFooterButtonCss,
  modalFooterWrapperCss,
  syncButtonCss,
  spanTextCss,
} from "./SyncClassesFromLMSInstructions.style";

const buttonId = "show_sync_class_from_lms_instructions_modal";

const SyncClassesFromLMSInstructions = () => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  const hideModal = useCallback(() => setActive(false), []);

  const showModal = useCallback(() => setActive(true), []);

  return (
    <>
      <span css={spanTextCss}>
        Newsela works with other LMS providers too.
        <Button
          id={buttonId}
          flavor={Button.flavors.tertiary}
          size={Button.sizes.sm}
          onClick={showModal}
          ref={triggerRef}
          __cssFor={syncButtonCss}
        >
          Sync classes from another provider?
        </Button>
      </span>
      <InfoModal
        {...modalProps}
        ariaProps={{
          "aria-labelledby": buttonId,
        }}
        onBackgroundClick={hideModal}
        title="Sync classes from LMS"
        footer={
          <div css={modalFooterWrapperCss}>
            <Button
              flavor={Button.flavors.primary}
              onClick={hideModal}
              __cssFor={modalFooterButtonCss}
            >
              Ok, thanks
            </Button>
          </div>
        }
        __cssFor={modalCss}
      >
        <div css={modalBodyWrapperCss}>
          <div css={lmsProvidersWrapper}>
            <GoogleClassroomIcon css={googleIconCss} />
            <CanvasIcon css={canvasIconCss} />
          </div>
          <div>
            <span>
              To sync classes from <strong>Google Classroom</strong>, sign in to
              Newsela using those credentials. To sync from{" "}
              <strong>Canvas</strong>, sign in through their platform directly.
            </span>
          </div>
        </div>
      </InfoModal>
    </>
  );
};

export default SyncClassesFromLMSInstructions;
